import React from 'react'
import Grid from '@mui/material/Grid2'
import { Typography } from '@mui/material'
import { formatPrice, getFacilityTypeText } from '../../../../../app/core/utils/utility'
import { FacilityData, IBoardOfDirector } from '../../../../../app/core/interfaces'
import { EFacilityStatusEnum } from '../../../../../app/core/utils/enums/UserProfile'

export const facilityStatusColor: Record<
  string,
  {
    label: string
    bgClass: string
    textClass: string
  }
> = {
  ACTIVE: {
    label: EFacilityStatusEnum['ACTIVE'],
    bgClass: 'rgba(77, 217, 56, 0.6)',
    textClass: '#000',
  },
  EXPIRED: {
    label: EFacilityStatusEnum['EXPIRED'],
    bgClass: 'rgba(230, 47, 37, 0.6)',
    textClass: '#000',
  },
}

const HeaderFacilityItem = ({ boardOfMemberInfo }: { boardOfMemberInfo: FacilityData[] }) => {
  return (
    <div className='w-100 d-flex flex-column'>
      {boardOfMemberInfo?.map((item, index) => (
        <Grid
          size={12}
          mb={1}
          width={'100%'}
          sx={{
            border: '0.5px solid #EAECF0',
            borderRadius: '8px',
            boxShadow: '0px 0px 10px 0px #1018280D',
          }}
        >
          <Grid
            p={2}
            width={'100%'}
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              background: 'rgba(7, 148, 85, 0.1)',
              border: '1px solid #EAECF0',
              borderRadius: '8px 8px 0px 0px',
            }}
          >
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'12px'}>
                {item?.facilityBranch}
              </Typography>
            </Grid>
            <Grid
              height={'24px'}
              width={'87px'}
              textAlign={'center'}
              sx={{
                backgroundColor: facilityStatusColor[item?.facilityStatus]?.bgClass,
                borderRadius: '4px',
              }}
            >
              <Typography
                variant='button'
                color={facilityStatusColor[item?.facilityStatus]?.textClass}
                fontSize={'12px'}
              >
                {facilityStatusColor[item?.facilityStatus]?.label}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            p={2}
            width={'100%'}
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              border: '1px solid #EAECF0',
            }}
          >
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                مبلغ تسهیلات :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {formatPrice(Number(item?.amountOrginal) || 0)} ریال
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                تاریخ تنظیم قرارداد :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {`${item?.facilitySetDate?.slice(0, 4)}/${item?.facilitySetDate?.slice(
                  4,
                  6
                )}/${item?.facilitySetDate?.slice(6, 8)}`}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                تاریخ سررسید نهایی :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {`${item?.facilityEndDate?.slice(0, 4)}/${item?.facilityEndDate?.slice(
                  4,
                  6
                )}/${item?.facilityEndDate?.slice(6, 8)}`}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                نوع عقد قرارداد تسهيلات :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {getFacilityTypeText(item?.facilityType || '')}
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                مجموع تسهیلات مانده :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {formatPrice(Number(item?.debtorTotalAmount) || 0)} ریال
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                مبلغ وجه التزام :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {formatPrice(Number(item?.facilityAmountObligation) || 0)} ریال
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                مانده معوقه :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {formatPrice(Number(item?.facilityDeferredAmount) || 0)} ریال
              </Typography>
            </Grid>
          </Grid>
          <Grid px={2} py={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                مانده مشکوک الوصول :
              </Typography>
            </Grid>
            <Grid display={'flex'} flexDirection={'column'}>
              <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                {formatPrice(Number(item?.facilitySuspiciousAmount) || 0)} ریال
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </div>
  )
}

export default HeaderFacilityItem
